import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as analyticsAPI from 'api/Settings/audioData';
import { isEmpty } from 'utils/redux';
import { TYPE_OF_FIELD_IN_COLUMN } from 'utils/scorecard';

const initialState = {
  data: null,
  metaData: {
    pageSize: 10,
    currentPage: 1,
    data: [],
    totalRecords: 0,
    ui: {
      loading: false,
      msg: ''
    },
    column: [
      // { title: '#', key: 'id', type: TYPE_OF_FIELD_IN_COLUMN.NUMBER, width: 120 },
      { title: 'Call meta data name', key: 'name', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'created at', key: 'created_at', type: TYPE_OF_FIELD_IN_COLUMN.STRING, width: 120 },
      { title: 'Action', key: 'Action', type: TYPE_OF_FIELD_IN_COLUMN.ACTIONS, width: 120 }
    ],
    status: 'init'
  },
  totalRecord: null,
  rangeDate: null,
  CardData: null,
  features_data: null,
  lowheader: null,
  highheader: null,
  highcomponent: null,
  lowcomponent: null,
  TabName: 'All',
  ui: {
    loading: false,
    msg: ''
  },
  status: ''
};

const getCustomerAudioDetails = createAsyncThunk('AudioData/getCustomerAudioDetails', async () => {
  const res = await analyticsAPI.GetCustomerDetails();
  // console.log("get customer audio details", res.data);
  return res.data;
});

const getCustomerMetaData = createAsyncThunk('AudioData/getCustomerMetaData', async (filter) => {
  const res = await analyticsAPI.GetCallMetaData(filter);
  // console.log("get customer meta data", res.data);
  return res.data;
});

const createMetaData = createAsyncThunk('AudioData/createMetaData', async (params) => {
  const res = await analyticsAPI.CreateCallMetaData(params);
  return res.data;
});

const updateMetaData = createAsyncThunk('AudioData/updateMetaData', async (params) => {
  const res = await analyticsAPI.UpdateCallMetaData(params);
  return res.data;
});

const deleteMetaData = createAsyncThunk('AudioData/deleteMetaData', async (id) => {
  const res = await analyticsAPI.DeleteCallMetaData(id);
  return res.data;
});

const SettingSlice = createSlice({
  name: 'AudioData',
  initialState: initialState,

  reducers: {
    resetState: () => {
      return initialState;
    },
    setCurrentPage: (state, action) => {
      state.metaData.currentPage = action.payload;
    },
    setPageSize: (state, action) => {
      state.metaData.pageSize = action.payload;
    }
  },
  extraReducers: {
    [getCustomerAudioDetails.pending]: (state) => {
      state.status = 'init';
      state.ui.loading = true;
    },

    [getCustomerAudioDetails.fulfilled]: (state, action) => {
      state.status = 'idle';
      state.ui.loading = false;

      if (isEmpty(action.payload)) {
        state.data = null;
      } else {
        state.data = action.payload;
      }
    },

    [getCustomerAudioDetails.rejected]: (state, action) => {
      console.log(action.error.message, 'action.error.message');
      state.status = 'error';
      state.error = action.error.message;
      state.ui.loading = false;
    },

    [getCustomerMetaData.pending]: (state) => {
      state.metaData.status = 'init';
      state.metaData.ui.loading = true;
    },

    [getCustomerMetaData.fulfilled]: (state, action) => {
      state.metaData.status = 'idle';
      state.metaData.ui.loading = false;

      if (isEmpty(action.payload)) {
        state.metaData.data = null;
      } else {
        state.metaData.data = action.payload;
        state.metaData.totalRecords = action.payload?.data?.count;
      }
    },

    [getCustomerMetaData.rejected]: (state, action) => {
      console.log(action.error.message, 'action.error.message');
      state.metaData.status = 'error';
      state.metaData.error = action.error.message;
      state.metaData.ui.loading = false;
    },

    [createMetaData.pending]: (state) => {
      state.metaData.status = 'init';
      state.metaData.ui.loading = true;
    },

    [createMetaData.fulfilled]: (state) => {
      state.metaData.status = 'idle';
      state.metaData.ui.loading = false;
      // state.metaData.data = [...state.metaData.data, action.payload]
    },

    [createMetaData.rejected]: (state, action) => {
      state.metaData.status = 'error';
      state.metaData.error = action.error.message;
      state.metaData.ui.loading = false;
    },

    [updateMetaData.pending]: (state) => {
      state.metaData.status = 'init';
      state.metaData.ui.loading = true;
    },

    [updateMetaData.fulfilled]: (state, action) => {
      state.metaData.status = 'idle';
      state.metaData.ui.loading = false;
      const updatedData = state?.metaData?.data?.data?.results?.map((item) => {
        if (item.id === action.payload.data.id) {
          return action.payload.data;
        }
        return item;
      });
      state.metaData.data.data.results = updatedData;
    },

    [updateMetaData.rejected]: (state, action) => {
      state.metaData.status = 'error';
      state.metaData.error = action.error.message;
      state.metaData.ui.loading = false;
    },

    [deleteMetaData.pending]: (state) => {
      state.metaData.status = 'init';
      state.metaData.ui.loading = true;
    },

    [deleteMetaData.fulfilled]: (state) => {
      state.metaData.status = 'idle';
      state.metaData.ui.loading = false;
    },

    [deleteMetaData.rejected]: (state, action) => {
      state.metaData.status = 'error';
      state.metaData.error = action.error.message;
      state.metaData.ui.loading = false;
    }
  }
});

export const { setCurrentPage, setPageSize } = SettingSlice.actions;

export default SettingSlice.reducer;

export { getCustomerAudioDetails, getCustomerMetaData, createMetaData, updateMetaData, deleteMetaData };
